// extracted by mini-css-extract-plugin
export default {"container":"style_container__jNjyL","title":"style_title__KMEJo","subtitle":"style_subtitle__EXbod","productsContainer":"style_productsContainer__Af3j2"};